export const RouteStatus = {
    NEW: 10,
    DISPATCHED: 20,
    BUSY: 30,
    FINISHED: 40,
    INTERRUPTED: 70
};